/* RIVO PURE — gallery automation, scroll reveal and sticky cart */
(()=>{
  const boot=()=>{
    const root=document.querySelector('#rivo-pure');
    if(!root || root.dataset.ready) return;
    root.dataset.ready='1';

    const thumbs=[...root.querySelectorAll('[data-rpu-photo]')];
    const picture=root.querySelector('#rpu-hero-image');
    const media=root.querySelector('.rpu-hero-media');
    const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    let index=0, timer=null, galleryVisible=true;
    let hovered=false, focused=false;
    function photo(i){
      if(!thumbs.length || !picture) return;
      index=(i+thumbs.length)%thumbs.length;
      const item=thumbs[index];
      picture.src=item.dataset.rpuPhoto;
      picture.alt=item.dataset.alt||'RIVO PURE';
      thumbs.forEach((t,n)=>{
        t.classList.toggle('is-active',n===index);
        t.setAttribute('aria-pressed',String(n===index));
      });
    }
    function stopTimer(){if(timer!==null){window.clearInterval(timer);timer=null;}}
    function syncAutoplay(){
      stopTimer();
      if(thumbs.length>1 && !reduceMotion.matches && !document.hidden && galleryVisible && !hovered && !focused){
        timer=window.setInterval(()=>photo(index+1),5500);
      }
    }
    thumbs.forEach((button,i)=>button.addEventListener('click',()=>{
      photo(i);
      syncAutoplay();
    }));
    if(media){
      media.addEventListener('mouseenter',()=>{hovered=true;syncAutoplay();});
      media.addEventListener('mouseleave',()=>{hovered=false;syncAutoplay();});
      media.addEventListener('focusin',()=>{focused=true;syncAutoplay();});
      media.addEventListener('focusout',e=>{
        if(!media.contains(e.relatedTarget)){focused=false;syncAutoplay();}
      });
      if('IntersectionObserver' in window){
        new IntersectionObserver(entries=>{
          galleryVisible=entries[0]?.isIntersecting??true;
          syncAutoplay();
        },{threshold:0.1}).observe(media);
      }
    }
    document.addEventListener('visibilitychange',syncAutoplay);
    if(reduceMotion.addEventListener) reduceMotion.addEventListener('change',syncAutoplay);
    else if(reduceMotion.addListener) reduceMotion.addListener(syncAutoplay);
    syncAutoplay();

    // Animate only below-the-fold sections. Without JS, every section stays visible.
    if(!reduceMotion.matches && 'IntersectionObserver' in window){
      const targets=[...root.querySelectorAll('.rpu-flush,.rpu-solution,.rpu-technology,.rpu-matches,.rpu-faq,.rpu-afterword')];
      const observer=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },{threshold:0.08,rootMargin:'0px 0px -5% 0px'});
      targets.forEach(section=>{
        if(section.getBoundingClientRect().top>window.innerHeight*0.85){
          section.classList.add('rpu-scroll-reveal');
          observer.observe(section);
        }
      });
    }

    const form=root.querySelector('.rpu-form');
    const buy=form?.querySelector('button[type="submit"]');
    const sticky=root.querySelector('#rpu-sticky');
    const stickyButton=sticky?.querySelector('[data-rpu-sticky-buy]');
    stickyButton?.addEventListener('click',()=>{
      if(form && buy && !buy.disabled) form.requestSubmit(buy);
    });
    if(sticky && buy && 'IntersectionObserver' in window){
      new IntersectionObserver(entries=>{
        const e=entries[0];
        const visible=!e.isIntersecting&&e.boundingClientRect.bottom<0;
        sticky.classList.toggle('is-visible',visible);
        sticky.setAttribute('aria-hidden',String(!visible));
        if(visible) sticky.removeAttribute('inert');
        else sticky.setAttribute('inert','');
      },{threshold:0}).observe(buy);
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();